import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export type CreateDepositorPayloadType = {
  email: string;
  mobile_phone: string;
  first_name: string;
  middle_name?: string;
  last_name: string;
};

export const createDepositorApi = (
  wireId: string,
  data: CreateDepositorPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/wires/${wireId}/depositor/`;

  return authApiService.POST(uri, data);
};
